var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"social-button",class:( _obj = {}, _obj[("variant-" + _vm.variant)] = _vm.variant, _obj ),attrs:{"href":_vm.url,"target":"_blak"}},[_c('img',{staticClass:"icon",attrs:{"src":require(("@/assets/img/social/" + _vm.variant + ".svg")),"alt":_vm.variant}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.socialName))])])}
var staticRenderFns = []

export { render, staticRenderFns }